function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5,15.828c-.159-.05-1.159-.5-.533-2.4h-.008A10.59,10.59,0,0,0,18.83,6.386c0-4.087-2.718-6.23-5.88-6.23S7.087,2.3,7.087,6.386a10.564,10.564,0,0,0,2.878,7.058c.638,1.676-.506,2.3-.743,2.384-3.309,1.2-7.19,3.379-7.19,5.534v.809c0,2.932,5.685,3.6,10.951,3.6S23.87,25.1,23.87,22.17v-.809C23.87,19.145,19.97,16.979,16.5,15.828Z",
  transform: "translate(-2.031 -0.156)"
});

var SvgContactsIcon = function SvgContactsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.839,
    height: 25.615,
    viewBox: "0 0 21.839 25.615",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContactsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contacts_icon.6fa5d584.svg";
export { ForwardRef as ReactComponent };